__turbopack_context__.v({
  "carousel": "_6rsk3G_carousel",
  "carouselAction": "_6rsk3G_carouselAction",
  "carouselActionContainer": "_6rsk3G_carouselActionContainer",
  "carouselActionContainerLeft": "_6rsk3G_carouselActionContainerLeft",
  "carouselActionContainerRight": "_6rsk3G_carouselActionContainerRight",
  "carouselActionLeft": "_6rsk3G_carouselActionLeft",
  "carouselActionRight": "_6rsk3G_carouselActionRight",
  "carouselContainer": "_6rsk3G_carouselContainer",
  "carouselMultiSlide": "_6rsk3G_carouselMultiSlide",
  "dot": "_6rsk3G_dot",
  "dotActive": "_6rsk3G_dotActive",
  "dotsContainer": "_6rsk3G_dotsContainer",
  "emptyCarouselSpace": "_6rsk3G_emptyCarouselSpace",
  "mediaContainer": "_6rsk3G_mediaContainer",
});
